/* 2026AW 特集ページ（sections/main-feature-aw.liquid）専用 */
(function(){
  var root = document.getElementById('aw26'); if (!root) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var wide = window.matchMedia('(min-width: 900px)');

  /* スマホはヘッダーが画面に固定で重なるため、その高さぶんメインビジュアルを下げる（写真の上が隠れないように） */
  var awHero = root.querySelector('.aw26-hero');
  function fitTop(){
    if (!awHero) return;
    var t = 0;
    ['.wh-bar', 'header.wh'].forEach(function(sel){
      var el = document.querySelector(sel);
      if (el && getComputedStyle(el).position === 'fixed' && el.offsetHeight) t += el.offsetHeight;
    });
    awHero.style.marginTop = t ? t + 'px' : '';
  }
  fitTop();
  addEventListener('resize', fitTop);
  addEventListener('load', fitTop);

  root.querySelectorAll('[data-aw-chars]').forEach(function(el){
    var t = el.textContent; el.textContent = '';
    for (var i = 0; i < t.length; i++){ var s = document.createElement('i'); s.style.setProperty('--i', i); s.textContent = t[i] === ' ' ? ' ' : t[i]; el.appendChild(s); }
  });
  root.querySelectorAll('[data-aw-split]').forEach(function(el){
    var words = el.textContent.trim().split(/\s+/), n = 0; el.textContent = '';
    words.forEach(function(w, k){
      var ws = document.createElement('span'); ws.style.cssText = 'display:inline-block;white-space:nowrap';
      for (var i = 0; i < w.length; i++){ var s = document.createElement('span'); s.className = 'ch'; s.style.setProperty('--i', n++); s.textContent = w[i]; ws.appendChild(s); }
      el.appendChild(ws); if (k < words.length - 1) el.appendChild(document.createTextNode(' '));
    });
  });
  var cur = root.querySelector('.aw26-cur'), wait = 0, seen = false;
  try { seen = sessionStorage.getItem('aw26-cur') === '1'; sessionStorage.setItem('aw26-cur', '1'); } catch (e) {}
  if (cur && !reduce && !seen){
    cur.classList.add('is-on'); wait = 1450;
    setTimeout(function(){ cur.classList.add('is-out'); }, 1400);
    setTimeout(function(){ cur.parentNode && cur.parentNode.removeChild(cur); }, 2700);
  } else if (cur){ cur.parentNode.removeChild(cur); }
  setTimeout(function(){ requestAnimationFrame(function(){ requestAnimationFrame(function(){ root.classList.add('is-ready'); }); }); }, wait);

  var targets = root.querySelectorAll('[data-aw-rv],[data-aw-split],[data-aw-img]');
  if (reduce || !('IntersectionObserver' in window)){
    targets.forEach(function(el){ el.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin:'0px 0px -12% 0px', threshold:0.12 });
    targets.forEach(function(el){ io.observe(el); });
  }

  var pars = [].slice.call(root.querySelectorAll('[data-aw-par]'));
  var prog = root.querySelector('.aw26-prog'), ticking = false;
  function onScroll(){
    var r0 = root.getBoundingClientRect(), h = r0.height - innerHeight;
    prog.style.transform = 'scaleX(' + Math.min(1, Math.max(0, h > 0 ? -r0.top / h : 0)) + ')';
    if (!reduce && wide.matches){
      pars.forEach(function(el){
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < -200 || r.top > innerHeight + 200) return;
        var c = (r.top + r.height / 2) - innerHeight / 2;
        el.style.transform = 'translate3d(0,' + (c * parseFloat(el.getAttribute('data-aw-par'))).toFixed(1) + 'px,0)';
      });
    }
    ticking = false;
  }
  addEventListener('scroll', function(){ if (!ticking){ ticking = true; requestAnimationFrame(onScroll); } }, { passive:true });
  onScroll();

  var peek = root.querySelector('.aw26-peek'), pimg = peek && peek.querySelector('img');
  if (peek && fine && !reduce){
    var mx = 0, my = 0, px = 0, py = 0, run = false;
    function loop(){ px += (mx - px) * .14; py += (my - py) * .14; peek.style.left = px + 'px'; peek.style.top = py + 'px'; if (run) requestAnimationFrame(loop); }
    root.querySelectorAll('[data-aw-peek]').forEach(function(a){
      a.addEventListener('mouseenter', function(e){ pimg.src = a.getAttribute('data-aw-peek'); mx = px = e.clientX + 140; my = py = e.clientY; peek.classList.add('is-on'); if (!run){ run = true; loop(); } });
      a.addEventListener('mousemove', function(e){ mx = e.clientX + 140; my = e.clientY; });
      a.addEventListener('mouseleave', function(){ peek.classList.remove('is-on'); setTimeout(function(){ if (!peek.classList.contains('is-on')) run = false; }, 500); });
    });
  }

  root.querySelectorAll('[data-aw-drag]').forEach(function(row){
    var down = false, sx = 0, sl = 0, moved = false;
    row.addEventListener('mousedown', function(e){ down = true; moved = false; sx = e.pageX; sl = row.scrollLeft; row.classList.add('is-drag'); e.preventDefault(); });
    addEventListener('mouseup', function(){ down = false; row.classList.remove('is-drag'); });
    row.addEventListener('mousemove', function(e){ if (!down) return; var d = e.pageX - sx; if (Math.abs(d) > 4) moved = true; row.scrollLeft = sl - d; });
    row.addEventListener('click', function(e){ if (moved){ e.preventDefault(); e.stopPropagation(); } }, true);
  });
})();